















import {
  Component,
  Vue,
  Emit,
  Prop,
  Provide,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, namespace } from "vuex-class";
import { IStringPerformanceSummary } from "../../models/interfaces/performance/string-performance-summary.model.interface";
import { formatService } from "../../services/format.service";
import { IZonePerformanceSummary } from "@/models/interfaces/performance/zone-performance-summary.model.interface";

const PropertyPerformanceModule = namespace("propertyPerformanceModule");

@Component
export default class PropertyDevicePerformanceTable extends Vue {
    @PropertyPerformanceModule.Getter public propertyZoneDevicePerformance;

    @Prop()
    public zoneCode: string;
    private items: IStringPerformanceSummary[] = [];
    private count: number;

    private columns = [
     {
      key: "id",
      label: "Device Size",
      sortable: true,
       formatter: (value, key, item) => {
        return formatService.formatDeviceSize(
          value
        );
      }
    },
    {
      key: "loads",
      sortable: true,
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.loads,
          this.calcTotalLoads()
        );
      }
    },
    {
      key: "impressions",
      sortable: true,
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.impressions,
          item.loads
        );
      }
    },
    {
      key: "keyPresses",
      label: "Engagements",
      sortable: true,
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.keyPresses,
          item.impressions
        );
      }
    },
    {
      key: "clicks",
      label: "Clicks",
      sortable: true,
      formatter: (value, key, item) => {
        return formatService.formatNumberPercentage(
          value,
          item.clicks,
          item.impressions
        );
      }
    }];


    public calcTotalLoads(): number {
      return this.items.map((b) => b.loads).reduce((a, b) => a + b, 0);
    }

    public created() {
        for (const key in this.propertyZoneDevicePerformance) {
            if (this.propertyZoneDevicePerformance.hasOwnProperty(key) && (key.toLowerCase() === this.zoneCode.toLowerCase())) {
               this.items = this.propertyZoneDevicePerformance[key];
            }
        }
    }
}
